import axios from "axios";

/**
 * Create a delivery in Rutario via our API endpoint
 * @param {Object} envio - The envio object from PickPack database
 * @param {Object} pedido - The pedido object from PickPack database
 * @returns {Promise<Object>} The created delivery response from Rutario
 */
export async function createDelivery(envio, pedido) {
	try {
		const response = await axios.post('/api/rutario-create', {
			envio,
			pedido
		});

		console.log('Rutario delivery created:', response.data);
		return response.data;
	} catch (error) {
		console.error('Error creating Rutario delivery:', error.response?.data || error.message);
		throw error;
	}
}

export default {
	createDelivery
};
